import { render, staticRenderFns } from "./FollowUpsTabela.vue?vue&type=template&id=56498c3f&scoped=true"
import script from "./FollowUpsTabela.vue?vue&type=script&setup=true&lang=js"
export * from "./FollowUpsTabela.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FollowUpsTabela.vue?vue&type=style&index=0&id=56498c3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56498c3f",
  null
  
)

export default component.exports